import React from 'react'
import { toast } from 'sonner'
import { customToast } from '@/shadcn/components/ui/custom-toast';
import { Button } from '@/shadcn/components/ui/button'

// Each variant maps to the sonner call that renders its themed icon (configured
// in shadcn/components/ui/sonner.tsx). Unmapped types fall back to a neutral toast.
const toastByType = {
    success: toast.success,
    error:   toast.error,
    warning: toast.warning,
    info:    toast.info,
    loading: toast.loading,
};

const toastOptionsByType = {
    success: {
        variant: "success",
    },
    error: {
        variant: "error",
        duration: Infinity,
        dismissible: true,
        closeButton: true
    },
    warning: {
        variant: "warning",
        duration: Infinity,
        closeButton: true,
        dismissible: true
    },
    info: {
        variant: "info",
        closeButton: true,
        dismissible: true
    },
    loading: {
        variant: "loading"
    }
}

// message  — toast title.
// type     — one of toastByType keys; anything else renders a neutral toast.
// options  — passed straight to sonner: { description, action: { label, onClick }, duration, ... }.
const makeToast = (message, type, options) => {
    // Don't stack an identical toast that's already on screen.
    if (toast.getToasts().some((t) => {
        if (t.title === message || (options && options.title === t.title)) {
            return true;
        }
        return false;
    })) {
        return;
    }

    if (type !== "custom") {
        // Into a fresh object: assigning into the shared defaults made one toast's title and
        // action stick to every later toast of the same type.
        const mergedOptions = Object.assign({}, toastOptionsByType[type], options);

        if (message && !mergedOptions.title) {
            mergedOptions.title = message;
        }
        customToast(mergedOptions);
    } else {
        options.variant = type;
        customToast(options)
    }
};

export default makeToast;
